import {Platform} from 'react-native';
import Animated from 'react-native-reanimated';
import {RFValue} from 'react-native-responsive-fontsize';
import Ionicons from 'react-native-vector-icons/dist/Ionicons';
import styled, {css} from 'styled-components/native';

export const Wrapper = styled(Animated.View)<{bottomOffset: number}>`
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: ${({bottomOffset}) => bottomOffset}px;
`;

export const Card = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  border-width: 1px;
  border-radius: 16px;
  padding: 12px;
  overflow: hidden;
  background-color: ${({theme}) => theme.colors.alert_blue_bg};
  border-color: ${({theme}) => theme.colors.alert_blue_border};

  ${Platform.select({
    ios: css`
      shadow-color: #000;
      shadow-offset: 0px 6px;
      shadow-opacity: 0.12;
      shadow-radius: 16px;
    `,
    android: css`
      elevation: 8;
    `,
  })}
`;

export const IconCircle = styled.View`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background-color: ${({theme}) => theme.colors.alert_blue_border};
`;

export const CardIcon = styled(Ionicons)`
  color: ${({theme}) => theme.colors.alert_blue_icon};
`;

export const CardText = styled.Text`
  flex: 1;
  font-size: 13px;
  font-family: ${({theme}) => theme.fonts.semibold};
  line-height: 18px;
  color: ${({theme}) => theme.colors.alert_blue_title};
`;

export const ProgressTrack = styled.View`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background-color: ${({theme}) => theme.colors.alert_blue_border};
`;

export const ProgressFill = styled(Animated.View)`
  height: 3px;
  background-color: ${({theme}) => theme.colors.alert_blue_icon};
`;
